import {
  HStack,
  Pressable,
  Text,
  VStack,
  SafeAreaView
} from "@gluestack-ui/themed";
import { Button } from "@repo/core/components/core/Button";
import { Icon } from "@repo/core/components/core/Icon";

import { useProposalsFiltersController } from "./controller";
import { productOptions, servicePointOptions, typeOptions } from "./mock";

import { ProposalsFiltersProps } from "./types";
import { useDeviceType } from "@repo/core/hooks/useDeviceType";
import { SelectControlled } from "@repo/core/components/forms/SelectControlled";

export const ProposalsFilters = ({ onCloseFilter }: ProposalsFiltersProps) => {
  const { control, onResetForm, onSubmitForm } = useProposalsFiltersController({
    onCloseFilter
  });

  const { isMobile } = useDeviceType();

  return (
    <VStack flex={1} overflow="hidden" height="$100vh">
      <SafeAreaView flex={1} bgColor="$white" h="$full">
        <HStack p="$4">
          <HStack flex={1} justifyContent={isMobile ? "center" : "flex-start"}>
            <Text
              fontFamily="Roboto"
              fontWeight={700}
              fontSize="$xl"
              color="$secondary700"
            >
              Filtros
            </Text>
          </HStack>
          <HStack>
            <Pressable onPress={onCloseFilter}>
              <Icon name="times" size={18} color="$secondary700" />
            </Pressable>
          </HStack>
        </HStack>
        <VStack gap="$4" p="$4" pb="$6" flex={4}>
          <SelectControlled
            control={control}
            name="type"
            isMultiple
            label="Tipo"
            placeholder="Filtrar por tipo de proposta"
            options={typeOptions}
          />

          <SelectControlled
            control={control}
            name="products"
            label="Produto"
            isMultiple
            placeholder="Filtrar por produto"
            options={productOptions}
          />

          <SelectControlled
            control={control}
            name="servicePoint"
            isMultiple
            label="Ponto de Atendimento"
            placeholder="Filtrar por PA"
            options={servicePointOptions}
          />
        </VStack>
        <VStack
          flex={1}
          px="$4"
          flexDirection={isMobile ? "column-reverse" : "row"}
          alignItems={isMobile ? "flex-start" : "flex-end"}
          p={isMobile ? "$0" : "$4"}
          justifyContent={isMobile ? "center" : "flex-end"}
          gap="$2"
        >
          <HStack>
            <Button
              w={isMobile ? "$full" : "$fit-content"}
              borderRadius={isMobile ? "$md" : "$lg"}
              size={isMobile ? "lg" : "sm"}
              variant="outline"
              onPress={onResetForm}
              text="Limpar filtros"
            />
          </HStack>
          <HStack>
            <Button
              borderRadius={isMobile ? "$md" : "$lg"}
              w={isMobile ? "$full" : "$fit-content"}
              size={isMobile ? "lg" : "sm"}
              text="Filtrar"
              onPress={onSubmitForm}
            />
          </HStack>
        </VStack>
      </SafeAreaView>
    </VStack>
  );
};
